import { CheckoutOrderValidationError, CheckoutOrderValidationRule } from "../enum/checkout-order-validation.enum";

export const checkoutOrderWorkDayRule: CheckoutOrderValidationRule = ({ workDayIsOpen }) =>
	workDayIsOpen === false ? CheckoutOrderValidationError.StoreClosed : null;
